import React from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components';
import ServiceRequestForm from '../components/ServiceRequestForm';
import { requestClientsTypeahead } from '../../../store/client-manager/ClientManagerActions';
import { requestPatient } from '../../../store/patients/PatientsActions';
import { hostTitle } from '../../../config/ui';
import {
  requestServiceRequestDetails, updateServiceRequest, createServiceRequest, createServiceRequestNew, requestPhoneTypes, requestServiceRequestStatuses,
  requestWorkLocationsByClient, requestServiceLocationsByService, uploadServiceRequestFiles, deleteServiceRequestFile, requestServiceOutcomeStatuses,
  createServiceRequestAppointment, updateServiceRequestAppointment, downloadServiceRequestFile, previewServiceRequestFile
}
  from '../../../store/service-request-manager/ServiceRequestManagerActions';
import { requestServiceTypeDetails } from '../../../store/services-manager/ServicesManagerActions';
import { requestServiceTypesByClient } from '../../../store/service-location-manager/ServiceLocationManagerActions';
import { requestStates } from '../../../store/referral-directory/ReferralDirectoryActions';
import { requestPatientsTypeahead } from '../../../store/patients/PatientsActions';
import { isExternalStakeholder, isCareNavigator, isSuperAdmin } from '../../../store/current-user/CurrentUserSelectors';
import FileViewer from 'react-file-viewer';
import Moment from '../../../components/utils/Moment';
import { Modal } from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import classNames from 'classnames';
import { humanFileSize } from '../../../components/utils/format';

class ServiceRequestEdit extends React.Component {
  constructor() {
    super();
    this.state = {
      files: [],
      showUpload: false,
      title: '',
      description: '',
      showPreview: false,
      btnName: ''
    };
    this.removeFileFromUploadList = this.removeFileFromUploadList.bind(this);
  }

  componentWillMount() {
    this.props.getServiceRequest(this.props.params.id, {
      tenantId: this.props.tenantId,
    });
  }

  getPatient = (masterPatientId) => {
    if (masterPatientId !== undefined) {
      return this.props.getPatientById(masterPatientId, {
        tenantId: this.props.tenantId,
      }).then((result) => {
        var data;
        if (result.payload.data) {
          data = result.payload.data[0];
        }
        return data;
      });
    }
  }

  searchClients = (search) => {
    return this.props
      .clientsTypeahead({
        tenantId: this.props.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ code: item.code, name: item.name }),
          );
        }
        return options;
      });
  };

  searchPatients = (search) => {
    return this.props
      .patientsTypeahead({
        tenantId: this.props.user.queryParams.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  searchServiceTypesByClient = (clientCode) => {
    clientCode = this.props.user.data.clients ? this.props.user.data.clients[0].code : '';
    return this.props
      .getServiceTypesByClient({
        tenantId: this.props.tenantId,
        clientCode: clientCode
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  searchWorkLocationsByClient = (clientCode) => {
    clientCode = this.props.user.data.clients ? this.props.user.data.clients[0].code : '';
    return this.props
      .getWorkLocationsByClient({
        tenantId: this.props.tenantId,
        clientCode: clientCode
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, location: item.name }),
          );
        }
        return options;
      });
  };

  getServiceTypeById = (typeId) => {
    return this.props.getServiceType(typeId, {
      tenantId: this.props.tenantId,
    }).then((result) => {
      var data;
        if (result.payload.data) {
          data = result.payload.data;
        }
        return data;
      });
  }

  searchServiceLocationsByService = (serviceTypeId) => {
    return this.props
      .getServiceLocationsByService({
        tenantId: this.props.tenantId,
        serviceTypeId: serviceTypeId
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, serviceProvider: item.name }),
          );
        }
        return options;
      });
  };

  searchPhoneTypes = () => {
    return this.props
      .getPhoneTypes({
        tenantId: this.props.tenantId
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  searchServiceRequestStatuses = () => {
    return this.props
      .getServiceRequestStatuses({
        tenantId: this.props.tenantId
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  searchServiceOutcomeStatuses = () => {
    return this.props
      .getServiceOutcomeStatuses({
        tenantId: this.props.tenantId
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  searchStates = () => {
    return this.props
      .getStates({
        tenantId: this.props.tenantId
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  onDrop(files) {
    if (this.state.files.length === 0) {
      const filesToAdd = _.difference(files, this.state.files);
      this.setState({ files: this.state.files.concat(filesToAdd) });
    }
  }

  onFileCancel() {
    this.setState({
      files: [],
    });
  }

  showModal() {
    this.setState({ showUpload: true });
  }

  closeModal() {
    this.setState({ showUpload: false });
    this.onFileCancel();
  }

  removeFileFromUploadList(fileName) {
    this.setState({
      files: this.state.files.filter((file) => file.name !== fileName),
    });
  }

  onStartUpload() {
    this.props
      .uploadFiles(
        this.props.params.id,
        {
          tenantId: this.props.user.queryParams.tenantId,
          //title: this.state.title,
          description: this.state.description
        },
        this.state.files,
      )
      .then((result) => {
        if (result.error) {
          const message = _.get(result, 'payload.response.error.message', null);
          if (message) {
            toast.error(message);
          } else {
            toast.error('Something went wrong. Try again later.');
          }
        } else {
          toast.success('Files have been uploaded.');
          this.setState({ showUpload: false, files: [] });
          this.props.getServiceRequest(this.props.params.id, {
            tenantId: this.props.user.queryParams.tenantId,
          });
        }
      });
  }

  handleTitleChange(event) {
    this.setState({ title: event.target.value });
  }

  handleDescriptionChange(event) {
    this.setState({ description: event.target.value });
  }

  deleteFile(serviceRequestId, fileName) {
    this.props
      .deleteFile(serviceRequestId, fileName,
        {
          tenantId: this.props.user.queryParams.tenantId,
        }
      )
      .then((result) => {
        if (result.error) {
          toast.error('Something went wrong. Try again later.');
        } else {
          toast.success('File has been deleted.');
          this.props.getServiceRequest(this.props.params.id, {
            tenantId: this.props.user.queryParams.tenantId,
          });
        }
      });
  }

  downloadFile(serviceRequestId, fileName) {
    this.props
      .downloadFile(
        serviceRequestId,
        {
          tenantId: this.props.user.queryParams.tenantId,
        },
        fileName,
      )
      .then((response) => {
        const blob = response.payload;
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      });
  }

  previewFile(serviceRequestId, filename) {
    this.props
      .previewFile(
        serviceRequestId,
        {
          tenantId: this.props.user.queryParams.tenantId,
        },
        filename,
      )
      .then((response) => {
        const blob = response.payload;
        var type = filename.substring(
          filename.lastIndexOf('.') + 1,
          filename.length,
        );
        this.setState({ fileName: URL.createObjectURL(blob) });
        this.setState({ fileType: type });
        this.setState({ showPreview: true });
      });
  }

  closePreview() {
    this.setState({ showPreview: false });
  }

  onSaveOther = (event) => {
    this.setState({ btnName: event.target.id });
  }

  onSubmit = (values) => {
    var clientName = this.props.user.data.clients ? this.props.user.data.clients[0].name : ''; 

    if (values.id !== '00000000-0000-0000-0000-000000000000') {
      this.props
        .updateServiceRequest(values, {
          tenantId: this.props.tenantId,
        })
        .then((result) => {
          if (result.error) {
            toast.error('Something went wrong. Try again later.');
          }
          else {
            if (values.appointments) {
              if (values.appointments.id === undefined && values.appointments.appointmentAt !== undefined) {
                this.props.createServiceRequestAppointment(
                  result.payload.data, values.appointments, {
                  tenantId: this.props.tenantId,
                })
                  .then((result) => {
                    if (result.error) {
                      toast.error('Something went wrong. Try again later.');
                    }
                  });
              }
              else if (values.appointments.id !== undefined) {
                this.props.updateServiceRequestAppointment(
                  result.payload.data, values.appointments, {
                  tenantId: this.props.tenantId,
                })
                  .then((result) => {
                    if (result.error) {
                      toast.error('Something went wrong. Try again later.');
                    }
                  });
              }
            }
          toast.success('Service Request has been updated.');
          hashHistory.push('/service-request-worklist/');
          }
        });
    }
    else {
      if (this.state.btnName === 'saveother') {
        this.props
          .createServiceRequestNew(values, {
            tenantId: this.props.tenantId,
            clientName: clientName
          })
          .then((result) => {
            if (result.error) {
              toast.error('Something went wrong. Try again later.');
            }
            else {
              toast.success('New Service Request has been created.');
            }
          });
      }
      else {
        this.props
          .createServiceRequest(values, {
            tenantId: this.props.tenantId,
            clientName: clientName
          })
          .then((result) => {
            if (result.error) {
              toast.error('Something went wrong. Try again later.');
            }
            else {
              toast.success('New Service Request has been created.');
              hashHistory.push('/service-request-worklist/');
            }
          });
      }
      this.setState({ btnName: '' });
    }
  };

  onCancel = () => {
    hashHistory.push('/service-request-worklist/');
  };

  render() {
    const {
      data: { serviceRequest,
        isLoading,
        isFilesUploading
      },
      user: { data },
      isExternalStakeholder,
      isSuperAdmin,
      isCareNavigator,
    } = this.props;

    const filesToUpload = this.state.files.map((file) => (
      <li className="list-group-item" key={file.name}>
        <span className="filename">{file.name}</span>
        <a
          className="action btn btn-xs btn-danger"
          onClick={() => this.removeFileFromUploadList(file.name)}
        >
          <i className="fa fa-close" />
        </a>
        <span className="badge">{humanFileSize(file.size)} bytes</span>
        <br />
        {/*<input className="form-control" placeholder="Title" onChange={this.handleTitleChange.bind(this)}></input>*/}
        <input className="form-control" placeholder="Description" onChange={this.handleDescriptionChange.bind(this)}></input>
      </li>
    ));

    const acceptedFiles =
      'image/jpeg, image/png, image/gif, image/x-icon, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-powerpoint, application/vnd.oasis.opendocument.text, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/x-photoshop, audio/mpeg, audio/x-m4a, application/ogg, video/mp4, video/mpeg4, video/x-m4v, video/quicktime, video/x-ms-wmv, video/avi, video/mpeg, video/ogg, video/3gpp, video/3gpp2';

    return (
      <div id="content">
        {serviceRequest.id && <Helmet title={`${serviceRequest.id} – ${hostTitle()}`} />}
        <BigBreadcrumbs
          items={[
            'Service Request Manager',
            { title: 'Service Request Worklist', route: '/service-request-worklist' },
            'Service Request',
          ]}
          icon="fa fa-fw fa-map"
          className=""
        />

        <WidgetGrid>
          <JarvisWidget
            color="white"
            fullscreenbutton={true}
            colorbutton={false}
            closeButton={true}
            editbutton={false}
            togglebutton={false}
            deletebutton={false}
          >
            <header>
              <span className="widget-icon">
                {' '}
                <i className="fa fa-table" />{' '}
              </span>
              <h2>{
                serviceRequest.id && `Edit Service Request `}
                {serviceRequest.id && <i>({serviceRequest.id})</i>}
                {!serviceRequest.id && `Add Service Request `}
              </h2>
            </header>
            <div>
              <div className="row">
                <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12 ">
                  <div className="row">
                    <div className="col-md-9">
                      <span> Service Request Id: {serviceRequest.code} </span>
                    </div>
                    <div className="col-md-3">
                      <button
                        className="btn btn-primary pull-right"
                        onClick={this.onCancel}
                      >
                        Back
                      </button>
                    </div>
                  </div>
                  {serviceRequest.id && (
                    <ServiceRequestForm
                      isLoading={isLoading}
                      searchClients={this.searchClients}
                      searchPatients={this.searchPatients}
                      getPatient={this.getPatient}
                      clients={data.clients}
                      searchServiceTypesByClient={this.searchServiceTypesByClient}
                      searchWorkLocationsByClient={this.searchWorkLocationsByClient}
                      searchServiceLocationsByService={this.searchServiceLocationsByService}
                      searchServiceRequestStatuses={this.searchServiceRequestStatuses}
                      searchServiceOutcomeStatuses={this.searchServiceOutcomeStatuses}
                      getServiceTypeById={this.getServiceTypeById}
                      searchPhoneTypes={this.searchPhoneTypes}
                      searchStates={this.searchStates}
                      mode={this.props.params.mode}
                      isExternalStakeholder={isExternalStakeholder}
                      onSubmit={this.onSubmit}
                      onSaveOther={this.onSaveOther}
                      onCancel={this.onCancel}
                    />
                  )}
                </div>

                {/* Attachments and History Section*/}
                {this.props.params.mode !== 'Add' && (
                  <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12 ">
                    <legend>Attachments</legend>
                    <small className="help-block">Image files, PDFs, Word, Excel, Audio, Video...</small>
                    <div className="form-group">
                      <div className="col-lg-12 padding-bottom-10">
                        {serviceRequest.files &&
                          serviceRequest.files.map((file) => (
                            <li className="list-group-item" key={file.fileName}>
                              <span className="filename">{(file.description !== null) ? file.description : file.fileName} </span>
                              {` `}
                              <button
                                className="btn btn-xs btn-default"
                                onClick={() =>
                                  this.downloadFile(serviceRequest.id, file.fileName)
                                }
                              >
                                <i className="fa fa-download" />
                              </button>
                              {` `}
                              <button
                                className="btn btn-xs btn-default"
                                onClick={() =>
                                  this.previewFile(serviceRequest.id, file.fileName)
                                }
                              >
                                <i className="fa fa-file" />
                              </button>
                              {` `}
                              <button disabled={!(isSuperAdmin || isCareNavigator)}
                                className="action btn btn-xs btn-danger"
                                onClick={() => this.deleteFile(serviceRequest.id, file.fileName)}
                              >
                                <i className="fa fa-close" />
                              </button>
                            </li>
                          ))}
                        <button
                          className="btn btn-primary"
                          onClick={this.showModal.bind(this)}
                        >
                          Add Attachment
                        </button>
                      </div>
                    </div>
                    <legend>History</legend>
                    {serviceRequest && serviceRequest.history && (
                      <div className="table-responsive">
                        <div className="col-lg-12">
                          <table className="table table-bordered table-condensed">
                            <thead>
                              <tr>
                                <th>Action</th>
                                <th>Name</th>
                                <th>Date</th>
                                <th>Time</th>
                                <th>User</th>
                              </tr>
                            </thead>
                            <tbody>
                              {serviceRequest && serviceRequest.history.map((rep) => (
                                <tr key={rep.id}>
                                  <td>{rep.action}</td>
                                  <td>{rep.name}</td>
                                  <td><Moment
                                    date={rep.createdAt}
                                    format="MM/DD/YYYY"
                                  /></td>
                                  <td><Moment
                                    date={rep.createdAt}
                                    format="hh:mm a"
                                  /></td>
                                  <td>{rep.createdByName}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                    {serviceRequest && !serviceRequest.history && <div>N/A</div>}
                  </div>
                )}
                <Modal show={this.state.showUpload}>
                  <Modal.Header>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-hidden="true"
                      onClick={this.closeModal.bind(this)}
                    >
                      &times;
                    </button>
                    <h4 className="modal-title" id="addFilesModalLabel">
                      Add Files
                    </h4>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="row client-files-upload">
                      <div
                        className={
                          this.state.files.length > 0
                            ? 'col-sm-12'
                            : 'col-sm-12'
                        }
                      >
                        <Dropzone
                          accept={acceptedFiles}
                          onDrop={this.onDrop.bind(this)}
                          onFileDialogCancel={this.onFileCancel.bind(this)}
                        >
                          {({
                            getRootProps,
                            getInputProps,
                            isDragActive,
                          }) => {
                            return (
                              <div
                                {...getRootProps()}
                                className={classNames(
                                  'dropzone dropzone-client-files',
                                  { 'dropzone--isActive': isDragActive },
                                )}
                              >
                                <input {...getInputProps()} />
                                {isDragActive ? (
                                  <p>Drop files here...</p>
                                ) : (
                                  <span className="text-center">
                                    <span className="font-lg visible-xs-block visible-sm-block visible-lg-block">
                                      <span className="font-lg">
                                        Drop files{' '}
                                        <span className="font-xs">
                                          to upload
                                        </span>
                                      </span>
                                      <span>
                                        &nbsp;&nbsp;
                                        <h4 className="display-inline">
                                          {' '}
                                          (Or Click)
                                        </h4>
                                      </span>
                                    </span>
                                  </span>
                                )}
                              </div>
                            );
                          }}
                        </Dropzone>
                      </div>
                      {this.state.files.length > 0 && (
                        <div className="col-sm-12">
                          <h4>Files to be uploaded</h4>
                          <ul className="list-group files-upload-list">
                            {filesToUpload}
                          </ul>
                          {` `}
                          {this.state.files.length === 1 && (
                            <h6 className="txt-color-red">Only one file per request accepted.</h6>
                          )}
                          {/* {this.state.files.length > 0 && <button className="btn btn-default" onClick={this.onCancel.bind(this)}>Clear</button>}{` `} */}
                        </div>
                      )}
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <button
                      type="button"
                      className="btn btn-default"
                      data-dismiss="modal"
                      onClick={this.closeModal.bind(this)}
                      disabled={isFilesUploading}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      disabled={this.state.files.length === 0}
                      onClick={this.onStartUpload.bind(this)}
                    >
                      Upload Files
                    </button>
                  </Modal.Footer>
                  {isFilesUploading && (
                    <div className="cover">
                      <div className="spinner" />
                    </div>
                  )}
                </Modal>

                <Modal
                  show={this.state.showPreview}
                  dialogClassName="modal-lg"
                >
                  <Modal.Header>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-hidden="true"
                      onClick={this.closePreview.bind(this)}
                    >
                      &times;
                    </button>
                    <h4 className="modal-title">File Viewer</h4>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="widget-body">
                      {
                        <FileViewer
                          fileType={this.state.fileType}
                          filePath={this.state.fileName}
                        />
                      }
                    </div>
                  </Modal.Body>
                </Modal>

              </div>
            </div>
          </JarvisWidget>
        </WidgetGrid>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    user: state.currentUser,
    data: state.servicerequestmanager,
    dataStates: state.referraldirectory,
    tenantId: state.currentUser.queryParams.tenantId,
    isExternalStakeholder: isExternalStakeholder(state),
    isCareNavigator: isCareNavigator(state),
    isSuperAdmin: isSuperAdmin(state),
  }),
  (dispatch) => ({
    getServiceRequest: (id, params) => dispatch(requestServiceRequestDetails(id, params)),
    createServiceRequest: (serviceRequest, params) => dispatch(createServiceRequest(serviceRequest, params)),
    createServiceRequestNew: (serviceRequest, params) => dispatch(createServiceRequestNew(serviceRequest, params)),
    updateServiceRequest: (serviceRequest, params) => dispatch(updateServiceRequest(serviceRequest, params)),
    clientsTypeahead: (params) => dispatch(requestClientsTypeahead(params)),
    getServiceTypesByClient: (params) => dispatch(requestServiceTypesByClient(params)),
    getWorkLocationsByClient: (params) => dispatch(requestWorkLocationsByClient(params)),
    getServiceLocationsByService: (params) => dispatch(requestServiceLocationsByService(params)),
    uploadFiles: (serviceRequestId, params, files) => dispatch(uploadServiceRequestFiles(serviceRequestId, params, files)),
    downloadFile: (serviceRequestId, params, fileName) => dispatch(downloadServiceRequestFile(serviceRequestId, params, fileName)),
    previewFile: (serviceRequestId, params, fileName) => dispatch(previewServiceRequestFile(serviceRequestId, params, fileName)),
    deleteFile: (serviceRequestId, fileName, params) => dispatch(deleteServiceRequestFile(serviceRequestId, fileName, params)),
    getStates: (params) => dispatch(requestStates(params)),
    getPatientById: (masterPatientId, params) => dispatch(requestPatient(masterPatientId, params)),
    getServiceType: (id, params) => dispatch(requestServiceTypeDetails(id, params)),
    getPhoneTypes: (params) => dispatch(requestPhoneTypes(params)),
    patientsTypeahead: (params) => dispatch(requestPatientsTypeahead(params)),
    getServiceRequestStatuses: (params) => dispatch(requestServiceRequestStatuses(params)),
    getServiceOutcomeStatuses: (params) => dispatch(requestServiceOutcomeStatuses(params)),
    createServiceRequestAppointment: (serviceRequestId, appointment, params) => dispatch(createServiceRequestAppointment(serviceRequestId, appointment, params)),
    updateServiceRequestAppointment: (serviceRequestId, appointment, params) => dispatch(updateServiceRequestAppointment(serviceRequestId, appointment, params)),
  }),
)(ServiceRequestEdit);



// WEBPACK FOOTER //
// ./src/routes/service-request-manager/containers/ServiceRequestEdit.js